import app from "flarum/forum/app";
import Component from "flarum/common/Component";
import Link from "flarum/common/components/Link";
import humanTime from "flarum/common/helpers/humanTime";
import FactGallery from "../../common/components/FactGallery";
import { expired, request, single, t } from "../../common/api";
export default class FactFeedCard extends Component {
  viewed = false;
  tracking = false;
  removed = false;
  oninit(vnode) {
    super.oninit(vnode);
    this.timer = setTimeout(() => m.redraw(), Math.max(0, Date.parse(this.attrs.story.expiresAt) - Date.now()));
    void this.track();
  }
  onupdate(vnode) {
    super.onupdate(vnode);
    void this.track();
  }
  onremove(vnode) {
    this.removed = true;
    clearTimeout(this.timer);
    super.onremove(vnode);
  }
  async track() {
    if (!this.attrs.active || this.viewed || this.tracking || expired(this.attrs.story)) return;
    this.tracking = true;
    try {
      const result = single(await request("/" + this.attrs.story.id + "/view", "POST"));
      if (!this.removed) this.attrs.story.counts.views = result.counts.views;
    } catch {
      /* The detail route remains the authoritative availability check. */
    } finally {
      this.tracking = false;
      this.viewed = true;
      if (!this.removed) m.redraw();
    }
  }
  view() {
    const story = this.attrs.story;
    if (expired(story)) return m("p", {
      className: "FactDetail-unavailable"
    }, t("unavailable"));
    const href = app.route("xgayFactShow", {
      id: story.id
    });
    const content = story.author.name.charAt(0).toUpperCase();
    return m("article", {
      className: "FactDetail FactDetail--viewer FactFeedCard"
    }, m(FactGallery, {
      story: story,
      viewer: true
    }), m("div", {
      className: "FactDetail-panel"
    }, m("header", {
      className: "FactDetail-header"
    }, m(Link, {
      className: "FactDetail-header-avatar",
      href: href
    }, story.author.avatar ? m("img", {
      src: story.author.avatar
    }) : m("span", {
      className: "FactDetail-header-name"
    }, content)), m("div", {
      className: "FactDetail-header-secondary"
    }, m(Link, {
      className: "FactDetail-header-username",
      href: href
    }, m("strong", null, story.author.name)), m("small", null, m("time", {
      datetime: story.createdAt
    }, humanTime(new Date(story.createdAt))), " ", "\xB7 ", t("views"), " ", story.counts.views))), story.images.length > 0 && story.content && m("div", {
      className: "FactDetail-caption"
    }, m("p", null, story.content)), m("div", {
      className: "FactDetail-actions"
    }, m(Link, {
      className: "Button Button--text",
      href: href
    }, t("like"), " ", story.counts.likes), m(Link, {
      className: "Button Button--text",
      href: href
    }, t("comments"), " ", story.counts.comments), m(Link, {
      className: "Button Button--primary",
      href: href
    }, t("view_detail")))));
  }
}
flarum.reg.add('xgay-fact', 'forum/components/FactFeedCard', FactFeedCard);